import { Component, OnInit } from '@angular/core';
import { faCheck, faSave, faTrashCan, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { AlertService } from '../alert.service';
import { ProjectBase } from '../project-base';
import { SettingService } from '../setting.service';
import { NgbModal, NgbModalRef, NgbPopover, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '@main/confirmation-modal/confirmation-modal.component';
import { NgFor, NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-settings-projects',
  templateUrl: './settings-projects.component.html',
  styleUrls: ['./settings-projects.component.css'],
  imports: [NgbPopover, FaIconComponent, NgFor, NgbTooltip, NgIf, ReactiveFormsModule]
})
export class SettingsProjectsComponent implements OnInit {

  // Modal
  public modalReference: NgbModalRef;

  // Forms
  optionalStageForm: UntypedFormGroup;

  // Properties
  bases: ProjectBase[] = [];

  // Font Awesome Properties
  faSave = faSave;
  faCheck = faCheck;
  faTrashCan = faTrashCan;
  faQuestion = faQuestion;

  constructor(private settingService: SettingService,
    private alertService: AlertService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.optionalStageForm = new UntypedFormGroup({
      bases: new UntypedFormControl(true),
      removal: new UntypedFormControl(),
      reviews: new UntypedFormControl(true)
    });
    this.getProjectBases();
    this.getProjectOptionalStages();
  }

  // Open Modal
  openModal(content: any): void {
    this.modalReference = this.modalService.open(content);
  }

  ngOnDestroy(): void {
    this.modalService.hasOpenModals() && this.modalService.dismissAll();
  }

  /* ----- Bases ----- */

  // Get Project Bases
  private getProjectBases(): void {
    this.settingService.getProjectBases().subscribe((bases) => {
      this.bases = bases;
    });
  }

  // Add Project Base
  addProjectBase(): void {
    const content = (<HTMLInputElement>document.getElementById('NEW_BASE_CONTENT')).value;
    if (content) {
      this.settingService.addProjectBase(content).subscribe(() => {
        this.alertService.showSuccessAlert('Project Base Added');
        this.getProjectBases();
        (<HTMLInputElement>document.getElementById('NEW_BASE_CONTENT')).value = null;
      });
    }
  }

  // Delete Project Base
  deleteProjectBase(base: any) {
    const confirmationModalRef = this.modalService.open(ConfirmationModalComponent);
    confirmationModalRef.componentInstance.message = `Are you sure you would like to delete this project base <b>"${base.content}"</b> ?`;
    confirmationModalRef.componentInstance.actionBtnTitle = "Delete";
    confirmationModalRef.componentInstance.confirmed.subscribe(() => {
      this.settingService.deleteProjectBase(base.id).subscribe(() => {
        this.alertService.showSuccessAlert('Project Base Deleted');
        this.getProjectBases();
      });
    });
  }

  // Get Optional Stages
  getProjectOptionalStages(): void {
    this.settingService.getProjectOptionalStages().subscribe((optionalStages: any) => {
      this.optionalStageForm.controls['removal'].setValue(optionalStages['REMOVAL']);
    });
  }

  // Save Optional Stages
  saveOptionalStages(): void {
    if (this.optionalStageForm.invalid) { return; }
    const payload = {
      BASES: this.optionalStageForm.value.bases || true,
      REMOVAL: this.optionalStageForm.value.removal,
      REVIEWS: this.optionalStageForm.value.reviews || true
    }
    this.settingService.saveOptionalStages(payload).subscribe(() => {
      this.alertService.showSuccessAlert('Updated Optional Stage');
      this.optionalStageForm.reset();
      this.getProjectOptionalStages();
    });
  }
}
